import { render, staticRenderFns } from "./Lata.vue?vue&type=template&id=0d31e24d&scoped=true&"
import script from "./Lata.vue?vue&type=script&lang=js&"
export * from "./Lata.vue?vue&type=script&lang=js&"
import style0 from "./Lata.vue?vue&type=style&index=0&id=0d31e24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31e24d",
  null
  
)

export default component.exports